// extracted by mini-css-extract-plugin
module.exports = {"container":"AddToBasketLocal_container___hMPj","confirmationBox":"AddToBasketLocal_confirmationBox__rfDpH"};